import React, { Component } from "react";
import TextField from "material-ui/TextField";
import RaisedButton from "material-ui/RaisedButton";
import styles from "styles";
import { addNotification } from "actions/notifications/notifications";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getIntegrators } from "actions/integrators/integrators";
import { emailRegExp } from "./../utils";

import axios from "axios";
export class AddIntegrator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      email: "",
      showForm: false,
      errors: {
        name: "",
        email: "",
      },
    };
    this.form = React.createRef();
    this.createIntegrator = this.createIntegrator.bind(this);
    this.toggleForm = this.toggleForm.bind(this);
    this.setEmail = this.setEmail.bind(this);
  }

  setEmail({ target: { value } }) {
    this.setState((state) => {
      const obj = {
        email: value,
      };
      if (value.match(emailRegExp)) {
        obj.errors = {
          ...state,
          email: "",
        };
      }
      return obj;
    });
  }

  toggleForm() {
    this.setState((state) =>
      state.showForm
        ? { showForm: !state.showForm, name: "", email: "", errors: {} }
        : { showForm: !state.showForm }
    );
  }

  createIntegrator(ev) {
    ev && ev.preventDefault();
    const { name, email } = this.state;
    if (name.length < 1 || email.length < 1) return;
    if (!email.match(emailRegExp)) {
      this.setState((state) => ({
        errors: { ...state.errors, email: "Invalid email!" },
      }));
      return;
    }
    const { addNotification, getIntegrators } = this.props;
    const { toggleForm } = this;
    axios({
      method: "post",
      url: `/api/v2/integrators`,
      data: {
        name,
        email,
      },
    })
      .then((integrator) => {
        addNotification({
          title: "Successful creation",
          message: "Integrator has been successfully created!",
          level: "success",
          _id: new Date().getMilliseconds(),
          autoDismiss: 3,
        });
        getIntegrators();
        toggleForm();
      })
      .catch((err) => {
        addNotification({
          title: "Creation error",
          message: "Integrator has not been created!" + err,
          level: "error",
          _id: new Date().getMilliseconds(),
          autoDismiss: 3,
        });
      });
  }

  render() {
    const { form, createIntegrator, toggleForm, setEmail } = this;
    const { name, email, showForm, errors } = this.state;
    return (
      <div
        className="row"
        style={{
          flexDirection: "column",
          alignItems: "flex-start",
          justifyContent: "flex-start",
          overflow: "hidden",
        }}
      >
        <RaisedButton
          onClick={toggleForm}
          label="Add Integrator"
          secondary
        ></RaisedButton>

        <div
          style={{
            maxHeight: showForm
              ? `${+form.current.offsetHeight + 100}px`
              : "0px",
            transition: "0.3s ease-in-out",
          }}
        >
          <form ref={form} method="POST" onSubmit={createIntegrator}>
            <div style={{ display: "flex" }}>
              <label htmlFor="name">
                <p style={styles.textLabel}>Name: </p>
                <TextField
                  value={name}
                  style={{ marginRight: "1rem" }}
                  name="name"
                  onChange={(ev) => this.setState({ name: ev.target.value })}
                  onKeyPress={(ev) => ev.which === 13 && createIntegrator()}
                ></TextField>
              </label>
              <label htmlFor="email">
                <p style={styles.textLabel}>Email: </p>
                <TextField
                  value={email}
                  name="email"
                  errorText={errors.email}
                  onChange={setEmail}
                  onKeyPress={(ev) => ev.which === 13 && createIntegrator()}
                ></TextField>
              </label>
            </div>
            <RaisedButton
              label="Create integrator"
              primary
              disabled={name.length < 1 || email.length < 1}
              style={{ marginTop: "0.5rem" }}
              onClick={createIntegrator}
            ></RaisedButton>
          </form>
        </div>
      </div>
    );
  }
}

export default connect(null, (dispatch) =>
  bindActionCreators(
    {
      addNotification,
      getIntegrators,
    },
    dispatch
  )
)(AddIntegrator);



// WEBPACK FOOTER //
// ./app/components/Integrators/List/AddIntegrator.jsx